import type { Oklch } from "./lib/palette";

/**
 * Brand colors. Edit these to retheme the entire app — each base spans a full
 * 50–950 palette (Tailwind classes like bg-primary-500, accent-100/40 etc).
 *
 * Picking values (see https://oklch.com/):
 *  - L (0–1): any value works — applyPalette() picks an action shade with
 *    ≥4.5:1 contrast adaptively. Near-black (L ~0.2) is grey-scale; mid-L
 *    (~0.55) gives a vivid brand action.
 *  - C (0–~0.37): 0 = grey, 0.10–0.20 = professional brand.
 *  - H (0–360°): 0 red · 90 yellow · 150 green · 200 cyan · 270 indigo · 330 pink.
 */
export const themeConfig: { primaryBase: Oklch; accentBase: Oklch } = {
  // Cozy lavender — light purple shades in light mode, deep purples in dark mode.
  primaryBase: { L: 0.62, C: 0.13, H: 305 },
  accentBase: { L: 0.585, C: 0.182, H: 277 },
};
